// import { Chip } from '@mui/material'
import { Chip } from '@nextui-org/react'

import { useRouter } from 'next/router'
import qs from 'qs'
import React from 'react'
import {
    Dropdown,
    DropdownTrigger,
    DropdownMenu,
    DropdownItem,
} from '@nextui-org/react'

import { Button } from '@nextui-org/react'
import cn from 'classnames'
import { buttonSearchCommonStyles, selectStyles } from '../common/styles'

export const VerifiedSelector = ({
    searchVerified,
    setSearchVerified,
    searchSearch,
    small = false,
}) => {
    const verifiedOptions = [
        { label: 'All', value: 'all' },
        { label: 'Verified', value: 'verified' },
        { label: 'Unverified', value: 'unverified' },
    ]

    if (
        ['assets', 'inventory'].includes(searchSearch) ||
        searchSearch === 'collections'
    )
        verifiedOptions.push({ label: 'Blacklisted', value: 'blacklisted' })

    let values = qs.parse(
        window.location.search.substring(1, window.location.search.length),
    )

    let defaultVerifiedOption = verifiedOptions[0]
    for (let i = 0; i < verifiedOptions.length; ++i) {
        if (verifiedOptions[i].value === searchVerified)
            defaultVerifiedOption = verifiedOptions[i]
    }

    const router = useRouter()

    const setQueryStringWithoutPageReloadPush = (qsValue) => {
        const newPath = window.location.pathname + '?' + qsValue

        router.push(newPath, undefined, { shallow: true })
    }

    const onChangeVerified = (value) => {
        setSearchVerified(value)
    }

    return (
        <div className="flex flex-wrap justify-center">
            <Dropdown offset={5} placement="bottom-end">
                <DropdownTrigger className="w-[56px]">
                    <Button
                        size="sm"
                        className={cn(
                            '!w-[56px] h-[56px] border-2',
                            buttonSearchCommonStyles,
                        )}
                        variant="bordered"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
                            />
                        </svg>
                    </Button>
                </DropdownTrigger>
                <DropdownMenu
                    variant="faded"
                    aria-label="Dropdown menu with description"
                    selectionMode="single"
                    selectedKeys={new Set([searchVerified])}
                    onSelectionChange={(d) => {
                        onChangeVerified(Array.from(d)[0])
                    }}
                >
                    {verifiedOptions.map((option) => (
                        <DropdownItem key={option.value} value={option.value}>
                            {option.label}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}
